import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const CareCanvas: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-mauve-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            viewBox="0 0 14 13"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-14 h-13 fill-white relative -top-1"
                        >
                            <path d="M4.98438 1.0625C5.35938 0.710938 5.875 0.5 6.39062 0.5H6.41406C7.5625 0.5 8.5 1.4375 8.5 2.58594C8.5 3.14844 8.26562 3.66406 7.89062 4.0625L3.41406 8.53906C3.29688 8.63281 3.25 8.77344 3.25 8.9375C3.25 9.24219 3.50781 9.5 3.8125 9.5C3.97656 9.5 4.11719 9.45312 4.23438 9.33594L9.4375 4.10938C9.83594 3.73438 10.3516 3.5 10.9141 3.5C12.0625 3.5 13 4.4375 13 5.58594C13 6.14844 12.7656 6.66406 12.3906 7.0625L10.3047 9.125C10.1172 9.33594 10 9.61719 10 9.89844C10 10.5078 10.4922 11 11.1016 11C11.2422 11 11.3828 10.9766 11.5234 10.9062L11.8984 10.7188C12.2734 10.5312 12.7188 10.6719 12.9062 11.0469C13.0938 11.4219 12.9531 11.8672 12.5781 12.0547L12.1797 12.2422C11.8516 12.4297 11.4766 12.5 11.1016 12.5C9.64844 12.5 8.5 11.3516 8.5 9.89844C8.5 9.21875 8.75781 8.5625 9.25 8.07031L11.3125 5.98438C11.4297 5.89062 11.5 5.75 11.5 5.58594C11.5 5.25781 11.2422 5 10.9141 5C10.75 5 10.6094 5.07031 10.5156 5.1875L5.28906 10.4141C4.89062 10.7891 4.375 11 3.8125 11C2.66406 11 1.75 10.0859 1.75 8.9375C1.75 8.375 1.96094 7.85938 2.33594 7.46094L6.8125 2.98438C6.92969 2.89062 7 2.72656 7 2.58594C7 2.25781 6.74219 2 6.41406 2H6.39062C6.22656 2 6.08594 2.07031 5.99219 2.16406L2.24219 5.5625C1.9375 5.84375 1.46875 5.82031 1.1875 5.51562C0.90625 5.21094 0.929688 4.74219 1.23438 4.46094L4.98438 1.0625Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={
                    <div className="font-700" id="care-canvas-left-id">
                        {sectionName || 'Canvas'}
                    </div>
                }
                key="careCanvas"
            >
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.care_canvas_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        care_canvas_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            care_canvas_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default CareCanvas;
